import React from "react";
import { Navigate } from "react-router-dom";

const AdminProtected = ({ children }) => {
  const adminToken = localStorage.getItem("admin_token");

  if (!adminToken) {
    return <Navigate to="/starmoonlight/login" replace />;
  }

  return children;
};

export default AdminProtected;
